import DimensionMultipleGraph from '../DimensionMultipleGraph.vue'
import { valueAsNumber, keepDimensions } from '../dataFilter'
import Config from '../config/DimensionMultipleGraph.vue'
import api from '../api'
import {Registry as graphs} from '../graph'

export default {
  id: 'multiple-graph',
  label: 'Graph Multiple',
  component: DimensionMultipleGraph,
  dimensions: 100,
  hideExport: true,
  recomputeDataOnPropsChange: true,
  multipleMeasure: (vue) => {
    try {
      const config = JSON.parse(vue.specialConfig)
      const graph = graphs.get(config.graph)
      if (graph) {
        return graph.multipleMeasure(vue)
      }
    } catch (error) {
      console.log('ERROR', error)
      return true
    }
  },
  adaptater: (data, vue) => {
    const props = {
      childProperties: null,
      columns: 3
    }
    try {
      const config = JSON.parse(vue.specialConfig)
      const graph = graphs.get(config.graph)
      if (graph) {
        const key = `Group${graph.dimensions}UniqueName`
        const byDimension = {}
        const result = []
        let min = null
        let max = null
        keepDimensions(graph.dimensions + 1, data).forEach(d => {          
          if (typeof byDimension[d[key]] === 'undefined') {
            byDimension[d[key]] = {
              UniqueName: d[key],
              Caption: d[`Group${graph.dimensions}Caption`],
              values: [],
              data: null,
              props: null
            }
            result.push(byDimension[d[key]])
          }
          byDimension[d[key]].values.push(d)
          vue.measure.forEach(m => {
            const val = valueAsNumber(d[api.measure.name(m)])
            if (min === null || min > val) {
              min = val
            }
            if (max === null || max < val) {
              max = val
            }
          })
        })
        vue.buildProps(props)
        const childProperties = vue.props.childProperties
        result.forEach(d => {
          d.data = graph.adaptater(d.values, vue)
          d.props = Object.assign({
            marginLeft: 0,
            marginRight: 0,
            min: min,
            max: max
          }, vue.props, childProperties)
        })
        if (graph.multipleGraphHandler) {
          graph.multipleGraphHandler(result, childProperties, vue)
        }
        props.subgraph = graph
        vue.buildProps(props)
        return result
      } else {
        vue.buildProps(props)
        return []
      }
    } catch (error) {
      console.log('ERROR', error)
      vue.buildProps(props)
      return []
    }
  },
  config: Config,
  queryHandler: (query, vue) => {
    try {
      const config = JSON.parse(vue.specialConfig)
      const graph = graphs.get(config.graph)
      if (graph) {
        query.groups = query.groups.slice(0, graph.dimensions + 1)
      } else {
        query.groups = []
      }
    } catch (error) {
      query.groups = []
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/DimensionMultipleGraph.js